































































import { Component, Prop, Vue } from "vue-property-decorator";
import i18n from "@/i18n";
import { UserGroup } from "@/services/users/types";
import { userGroupFields } from "@/components/users/fields/userGroupsFields";
import { getAllUserGroups } from "@/services/users/userGroupService";

    @Component
export default class SelectUserGroupModal extends Vue {
        // local state
        groups = [] as Array<UserGroup>;
        isBusy = false;
        fields = userGroupFields;
        sortBy = "name";
        sortDesc = false;
        multiPicker = false;
        selectedUserGroups = [] as UserGroup[];
        // filter options
        searchQuery = "";
        // lifecycle hooks

        public created() {
            this.fetchData();
        }

        // computed
        get filteredData() {
            return this.groups && this.groups
                .filter(x => this.searchQuery.length === 0 ||
                    (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                        x.description.toLowerCase().includes(this.searchQuery.toLowerCase())));
        }

        get title(): string {
            return i18n.t("users.selectUserGroup").toString();
        }

        // methods
        fetchData() {
            this.isBusy = true;
            getAllUserGroups().then((response: any) => {
                this.groups = response;
                this.isBusy = false;
            });
        }

        rowSelected(items: UserGroup[]) {
            this.selectedUserGroups = items;
        }

        open(multiPicker = false) {
            this.multiPicker = multiPicker;
            this.fetchData();
            this.$bvModal.show("modal-selectUserGroup");
        }

        save() {
            this.$bvModal.hide("modal-selectUserGroup");
            if (!this.selectedUserGroups || this.selectedUserGroups.length === 0) {
                return;
            }

            this.$emit("select", this.selectedUserGroups);
        }

        resetState() {
            this.searchQuery = "";
            this.selectedUserGroups = [] as UserGroup[];
        }
}
